import { useIntl } from 'react-intl';

import { facet } from '@app/components';
import { useFeatureFlag } from '@app/hooks';
import { sharedMessages } from '@app/translations';
import { Feature } from '@app/constants';

import { FacetInstanceDto } from '../constants';

export const useInitialFacets = (): Partial<FacetInstanceDto> => {
  const { $t } = useIntl();
  const statusSearchFacetFlag = useFeatureFlag({
    name: Feature.statusSearchFacet,
  });
  const contributorsFacetFlag = useFeatureFlag({
    name: Feature.contributorsFacet,
  });
  const genreFacetFlag = useFeatureFlag({
    name: Feature.genreFacet,
    isActiveIfNotFound: true,
  });

  const getFeatureFlagControlledFacet = (
    shouldDisplay: boolean,
    facetConfig: Partial<FacetInstanceDto>
  ) => (shouldDisplay ? facetConfig : {});

  return {
    ...getFeatureFlagControlledFacet(statusSearchFacetFlag.isActive, {
      [facet.status]: { label: $t(sharedMessages.itemStatus), values: null },
    }),
    [facet.format]: { label: $t(sharedMessages.format), values: null },
    [facet.location]: { label: $t(sharedMessages.location), values: null },
    [facet.publisher]: { label: $t(sharedMessages.publisher), values: null },
    [facet.language]: { label: $t(sharedMessages.language), values: null },
    [facet.subject]: { label: $t(sharedMessages.subject), values: null },
    ...getFeatureFlagControlledFacet(contributorsFacetFlag.isActive, {
      [facet.contributor]: {
        label: $t(sharedMessages.contributor),
        values: null,
      },
      [facet.organization]: {
        label: $t({
          id: 'filterPane.organization',
          defaultMessage: 'Organization',
        }),
        values: null,
      },
    }),
    ...getFeatureFlagControlledFacet(genreFacetFlag.isActive, {
      [facet.genre]: {
        label: $t({ id: 'filterPane.genreForm', defaultMessage: 'Genre/Form' }),
        values: null,
      },
    }),
  };
};
